import {Component,OnInit,ViewEncapsulation,HostListener,Input} from '@angular/core';
import {animate,state,style,transition,trigger,} from '@angular/animations';

import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { HttpClient } from '@angular/common/http';
import { CONFIG } from './../../../_config/config';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';

import { QueryStates } from '../query/query.reducer';
import * as actions from '../query/query.actions';
import { MenuService } from './menu.service';


@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss'],
  animations: [
    trigger('toggleHeight', [
      state('close', style({
        height: '0',
        overflow: 'hidden',
        marginBottom: '0',
        display: 'none',

      })),
      state('open', style({
        display: 'block',
        height: '*',
        marginBottom: '10px',
        overflow: 'hidden',
      })),
      transition('close => open', animate('140ms ease-in')),
      transition('open => close', animate('140ms ease-out'))
    ])
  ],
  encapsulation: ViewEncapsulation.None
})
export class MenuComponent implements OnInit {

  urlQuery = 'query/';
  menuItems = new Array();
  menuItemsOptional =  new Array();

  currentItem = null;
  currentRootItem = null;
  isPerfectScrollbarDisabled = false;

  public config: PerfectScrollbarConfigInterface = {};

  constructor( private http: HttpClient, private router: Router ,
               private menuService: MenuService,               
               private store: Store<QueryStates>) { }

  ngOnInit() {
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.togglePerfectScrollbar();
    });
  }

  @HostListener('window:resize', [])
  onResize() {
    this.togglePerfectScrollbar();
  }

  togglePerfectScrollbar() {
    this.isPerfectScrollbarDisabled = window.innerWidth < 1025;
  }

  @Input()
  set Items(value) {
    if (value) {
      this.menuItems = Array.from(value);
      this.menuItemsOptional = Array.from(value);
    }
  }

  toggleNavigationSub(event, item) {
    try {
      event.preventDefault();
    } catch (error) {
    }
    if (this.currentItem && !item.parentLabel && this.currentItem !== item ) {
      this.currentRootItem.toggle = 'close';
      // this.currentItem.toggle = 'close';
    }
    if (!item.parentLabel) {
      this.currentRootItem = item;
    }
    this.currentItem = item;
    item.toggle = (item.toggle === 'close' ? 'open' : 'close');
  }

  toggleClose() {
    // cerrar inmediatamente el item despues de abierto el submenu
    // const item = this.currentItem ;
    // this.toggleNavigationSub(null, item);
}

goPath(data) {
  console.log('Cambio estado' , data.label);
  let loadCounter = false;
  const currentMenuItem = JSON.parse(sessionStorage.getItem('currentoption'));

  if ((currentMenuItem != null && currentMenuItem.menuItemId !== data.menuItemId)
       || (currentMenuItem == null)  )
    {
      console.log('Cargar datos' , data.label);
      this.menuService.setCountMenu(data.menuItemId).subscribe((res:string) => {
        const MenuItem = Object.assign({} , data) ;
        MenuItem["counter"] = res ;
        sessionStorage.setItem('currentoption', JSON.stringify(MenuItem));
      });

    }

  this.store.dispatch(actions.resetProcess());
  this.router.navigate([`/labviewer/queries`,data.label,data.routerLink,data.menuItemBasedOnId ]);
}

  filterMenu(searchText: string) {
    // metodo de filtrado de menu segun parametro de busqueda (searchText)

    if (!this.menuItems) { return  }
    if (!searchText) {
      this.menuItems = this.menuItemsOptional; 
      this.menuItems.map( record => {
        record.toggle = 'close'
      });
      return
    }

    if(searchText.length === 1) {
      this.menuItems.map( record => {
        record.toggle = 'open';
      });
    }

    searchText = searchText.toLowerCase();
    this.menuItems = this.menuItemsOptional.filter(menu => {
      let count = 0;
      if (!(typeof(menu.submenu) === 'undefined')) {
       menu.submenu.forEach(element => {
          if(element.label.toLowerCase().includes(searchText)) {
            count = count + 1;
          }
        });
      }
      return count > 0;
    });
  }
}
